import { styled, type SxProps, type Theme } from "~/common/mui";

interface Props {
  className?: string;
  sx?: SxProps<Theme>;
  src: string;
  sliceSize?: number;
  gapSize?: number;
}

const SlicedRoot = styled("div", {
  shouldForwardProp: (prop) => prop !== "sliceSize" && prop !== "gapSize",
})<{ sliceSize: number; gapSize: number }>(({ sliceSize, gapSize }) => ({
  display: "inline-flex",
  position: "relative",
  background: `repeating-linear-gradient(to right, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1) ${sliceSize}px, rgba(255, 255, 255, 0) ${sliceSize}px, rgba(255, 255, 255, 0) ${sliceSize + gapSize}px)`,
  mixBlendMode: "multiply",
}));

const ScreenImage = styled("img")({
  mixBlendMode: "screen",
});

export const SlicedImage = ({ className, sx, sliceSize = 1, gapSize = 1, src }: Props) => {
  return (
    <SlicedRoot className={className} sx={sx} sliceSize={sliceSize} gapSize={gapSize}>
      <ScreenImage src={src} />
    </SlicedRoot>
  );
};
